export default {
    list: 'customer/list',
    add: 'customer/add',
    edit: 'customer/edit',
    salesPerson: 'customer/salesPerson',
    detail: 'customer/detail',
    adhocCharges: 'customer/adhocCharges',
    setAddress: 'customer/setAddress',
    setSalesPerson: 'customer/setSalesPerson',

    changeAccountNumber: 'customer/changeAccountNumber',
    close: 'customer/close',
    suspend: 'customer/suspend',
    validate: 'customer/validate',
    activate: 'customer/activate',

    addContact: 'customer/addContact',
    editContact: 'customer/editContact',
    deleteContact: 'customer/deleteContact',

    productsList: 'customer/productsList',

    chargeGeneralAdhoc: 'provisioningProfile/generalAdhoc',

    addProduct: 'customer/addProduct'
};